/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Votes_UnavailableInputs */

const en_us2_community_votes_unavailable = /** @type {(inputs: Community_Votes_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to vote.`)
};

const pt_br2_community_votes_unavailable = /** @type {(inputs: Community_Votes_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para votar.`)
};

const es_419_community_votes_unavailable = /** @type {(inputs: Community_Votes_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctate a internet para votar.`)
};

const pt_pt2_community_votes_unavailable = /** @type {(inputs: Community_Votes_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liga-te à internet para votar.`)
};

const fr_fr2_community_votes_unavailable = /** @type {(inputs: Community_Votes_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecte-toi à Internet pour voter.`)
};

const de_de2_community_votes_unavailable = /** @type {(inputs: Community_Votes_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde dich mit dem Internet, um abzustimmen.`)
};

const it_it2_community_votes_unavailable = /** @type {(inputs: Community_Votes_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connettiti a internet per votare.`)
};

/**
* | output |
* | --- |
* | "Connect to the internet to vote." |
*
* @param {Community_Votes_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_votes_unavailable = /** @type {((inputs?: Community_Votes_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Votes_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_votes_unavailable(inputs)
	if (locale === "es-419") return es_419_community_votes_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_community_votes_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_community_votes_unavailable(inputs)
	if (locale === "de-DE") return de_de2_community_votes_unavailable(inputs)
	if (locale === "it-IT") return it_it2_community_votes_unavailable(inputs)
	return en_us2_community_votes_unavailable(inputs)
});
export { community_votes_unavailable as "community.votes_unavailable" }